export default __webpack_public_path__ + "static/media/rubirosa.894b682f.jpeg";